export const MAINTENANCE_STATUS = 'maintenance' as const;

export interface IMaintenanceStatus {
  status: typeof MAINTENANCE_STATUS;
  deploymentId: string;
  startedAt: string;
  expectedUntil: string;
  retryAfterSeconds: number;
  message: string;
}

function record(value: unknown): Record<string, unknown> | null {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

function validTimestamp(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0 && Number.isFinite(Date.parse(value));
}

export function parseMaintenanceStatus(value: unknown): IMaintenanceStatus | null {
  const candidate = record(value);
  if (
    candidate?.status !== MAINTENANCE_STATUS ||
    typeof candidate.deploymentId !== 'string' ||
    candidate.deploymentId.trim().length === 0 ||
    !validTimestamp(candidate.startedAt) ||
    !validTimestamp(candidate.expectedUntil) ||
    typeof candidate.retryAfterSeconds !== 'number' ||
    !Number.isInteger(candidate.retryAfterSeconds) ||
    candidate.retryAfterSeconds < 1 ||
    candidate.retryAfterSeconds > 300 ||
    typeof candidate.message !== 'string' ||
    candidate.message.trim().length === 0
  ) {
    return null;
  }

  return {
    status: MAINTENANCE_STATUS,
    deploymentId: candidate.deploymentId,
    startedAt: new Date(candidate.startedAt).toISOString(),
    expectedUntil: new Date(candidate.expectedUntil).toISOString(),
    retryAfterSeconds: candidate.retryAfterSeconds,
    message: candidate.message,
  };
}

export function isMaintenanceStatusExpired(
  status: IMaintenanceStatus,
  now: number | Date = Date.now(),
): boolean {
  const timestamp = now instanceof Date ? now.getTime() : now;
  return Date.parse(status.expectedUntil) <= timestamp;
}
